export default {
  'Text': 'テキスト',
  'Styles': 'スタイル',
  'Text here': 'ここにテキストを入力してください',
  'Add subtitles': 'サブタイトルを追加',
  'Text Color': 'テキストカラー',
  'Outline': '外側',
  'Background': '背景',
  'Position': '位置',
}